(ns dre.components.search-results.views.article
  (:require
   ["antd" :refer [Popover Card]]
   [clojure.string :as str]
   [dre.app.router :as router :refer [->route]]
   [dre.coll :refer [distinct-by]]
   [dre.common.document-util :as document-util]
   [dre.components.icon :refer [svg icon fa-icon]]
   [dre.components.inputs :refer [checkbox]]
   [dre.components.loading-spinner :refer [loading-spinner]]
   [dre.components.search-results.annotations :as annotations]
   [dre.components.tooltip :refer [tooltip-wrapper]]
   [dre.components.search-results.events :as results]
   [dre.components.search-results.views.article-meta :as meta]
   [dre.i18n.views :refer [tr]]
   [dre.i18n.events :as-alias i18n]
   [dre.modals.events :as-alias modals]
   [dre.pages.detail.events :as detail-events]
   [dre.pages.my-searches.tags.events :as tag-events]
   [dre.pages.my-searches.tags.views :refer [tags-filter]]
   [dre.pages.my-searches.tags.utils :refer [tag-pill tag-of-current-user?]]
   [dre.util :refer [ensure-sentence]]
   [dre.utils :refer [dre-user? dev-role? admin-role?]]
   [dre.utils.bem :as bem]
   [dre.widgets.events :as-alias widgets-events]
   [dre.widgets.question-answering.events :as qa-events]
   [goog.string :as gstring]
   [reagent.core :as r]
   [re-frame.core :as rf]
   [reagent.format :refer [format]]))


(def component-name :results-article)


(defn select
  [{:keys [guid]} {:keys [selected]}]
  (let [selected? (contains? selected guid)]
    [checkbox
     {:checked selected?
      :on-change #(rf/dispatch [::results/toggle-selected guid])}]))


(defn- count-selected [articles tags tag_uuid]
  (count (filter (fn [article]
                   (some #(= tag_uuid (str (:tag_uuid %)))
                         (get tags [(:source article)
                                    (:uri article)])))
                 articles)))

(defn tags-selector
  ([article selected-articles utags all-tags-filtered user close-fn]
   (tags-selector article selected-articles utags all-tags-filtered user close-fn nil))
  ([article selected-articles utags all-tags-filtered user close-fn articles-by-guids]
  (let [tags-loading? @(rf/subscribe [::tag-events/loading?])
        article-id (:guid article)
        articles (if article #{article-id}
                     selected-articles)
        articles (if (seq articles-by-guids)
                   (filter #(contains? articles (:guid %)) articles-by-guids)
                   @(rf/subscribe [::results/articles-by-guids articles]))
        current-user-tags (filter (partial tag-of-current-user? user) all-tags-filtered)
        opts (keep (fn [o]
                     (assoc o :selected-count
                            (count-selected articles utags (:tag_uuid o)))) current-user-tags)]
    [:div
     {:class (bem/be component-name :tags-selector)}
     [:> Card
      {:title @(rf/subscribe [::i18n/translate "Apply tags"])
       :bordered false
       :style {:boxShadow "none"}
       :extra (r/as-element [:span.extra
                             [:div.settings
                              {:onClick #(rf/dispatch [::router/redirect-to-path (router/->route :tags)])}
                              [fa-icon :settings]]
                             [:div.close
                              {:onClick close-fn}
                              [fa-icon :x-mark]]])
       :actions [(r/as-element [:div.new-tag
                                {:onClick (fn [e]
                                            (close-fn)
                                            (rf/dispatch
                                             [::modals/set-modal
                                              :my-searches.tags/edit
                                              {:data-edit
                                               {:name @(rf/subscribe [::tag-events/tag-filter])
                                                :source+uris (map (fn [article]
                                                                    {:source (:source article)
                                                                     :uri (:uri article)}) articles)
                                                :after-fx [::results/fetch-articles-tags articles-by-guids]}}]))}
                                [tr "Create new tag"]])]}
      [:<>
       [:div.filter
        [tags-filter]]
       (if tags-loading?
         [:div.items
         [:div
         {:style {:width "100%"
                  :display "flex"
                  :justifyContent "center"
                  :height "30px"}}
          [loading-spinner]]]
         [:div.items
          (doall
           (for [t opts]
             (let [selected-count (:selected-count t)
                   all-selected (= selected-count (count articles))
                   some-selected (and (not all-selected)
                                      (pos? selected-count))
                   assign-fn (fn [action]
                               #(let [actions (map (fn [article]
                                                     {:source (:source article)
                                                      :uri (:uri article)
                                                      :tag_uuid (:tag_uuid t)
                                                      :tag t
                                                      :action action}) articles)]
                                  (rf/dispatch [::results/tag-articles actions articles-by-guids])))
                   assign (assign-fn "assign")
                   unassign (assign-fn "unassign")]
               ^{:key (:tag_uuid t)}
               [:div.item
                {:class [(when (or some-selected all-selected) :active)]
                 :onClick (fn []
                            (if all-selected
                              (unassign)
                              (assign))
                            true)}
                [tag-pill t user]
                [:span {:class :active-icon}
                 (cond
                   all-selected
                   [fa-icon :check]
                   some-selected
                   [fa-icon :minus]
                   :else
                   nil)]])))])]]])))

(defn- tag-content
  [_article _selected-articles _tags _utags _all-tags-filtered _user]
  (let [open? (r/atom false)
        close-fn #(reset! open? false)]
    (fn [article selected-articles tags utags all-tags-filtered user]
      [:> Popover
       {:content (r/as-element [:div
                                (doall
                                 (for [t tags]
                                   ^{:key (:tag_uuid t)}
                                   [tag-pill t user]))])
        :trigger :hover}
       [:> Popover
        {:content (r/as-element [tags-selector article selected-articles utags all-tags-filtered user close-fn])
         :trigger :click
         :open @open?
         :on-open-change (fn [v] (reset! open? v))}
        [:span
         {:class (bem/be component-name :col-tag-icon)}
         [icon :common :tag]]]])))

(defn- tag-empty-content
  [_article _selected-articles _utags _all-tags-filtered _user]
  (let [open? (r/atom false)
        close-fn #(reset! open? false)]
    (fn [article selected-articles utags all-tags-filtered user]
      [tooltip-wrapper "Tag articles with your own custom label."
       [:> Popover
        {:content (r/as-element [tags-selector article selected-articles utags all-tags-filtered user close-fn])
         :trigger :click
         :open @open?
         :on-open-change (fn [v] (reset! open? v))}
        [:span
         {:class (bem/be component-name :col-tag-icon)}
         [icon :common :tag-empty]]]])))

(defn tag
  [a state user]
  (let [tags-loading? @(rf/subscribe [::tag-events/loading?])
        all-tags @(rf/subscribe [::tag-events/tags-without-filter])
        all-tags-filtered @(rf/subscribe [::tag-events/tags])
        tag_uuids (set (map :tag_uuid all-tags))
        utags (get state :articles-utags)
        tags (get utags [(:source a)
                           (:uri a)])
        selected-articles (:selected state)
        ;; consistenty check
        tags (seq (distinct-by :tag_uuid (filter #(contains? tag_uuids (:tag_uuid %)) tags)))
        ]
    (if tags-loading?
      [:span
       {:class (bem/be component-name :col-tag-icon)}
       [loading-spinner]]
      (if tags
        [tag-content a selected-articles tags utags all-tags-filtered user]
        [tag-empty-content a selected-articles utags all-tags-filtered user]))))

(defn index
  [{:keys [index]} {:keys [offset]}]
  (+ index offset))


(defn title
  [{:keys [title alt-title title-boldings guid index]}]
  [:div
   {:class (bem/be component-name :title)}
   [:a
    {:on-click #(rf/dispatch [::results/set-clicked-article index [::detail-events/optimistic-prev-next]])
     :href (->route :detail {:id guid})}
    [annotations/annotate
     (cond (not (str/blank? title)) title
           (not (str/blank? alt-title)) alt-title
           :else "-")
     title-boldings
     nil]]])


(defn title-nonclickable
  [{:keys [title alt-title title-boldings guid index]}]
  [:div
   {:class (bem/be component-name :title)}
   [:span
    [annotations/annotate
     (cond (not (str/blank? title)) title
           (not (str/blank? alt-title)) alt-title
           :else "-")
     title-boldings
     nil]]])

;; C/P'ed from dre.search.widgets-items
(defn annotation-span
  [text title title?]
  (if (str/blank? text)
    [0 0]
    (let [text (str/lower-case text)
          title (or title "")
          title (ensure-sentence (str/lower-case title))
          title-count (count title)
          title-index (str/index-of text title)
          has-title? (and title-index
                          (or (zero? title-index)
                              (str/blank?
                               (subs text 0 title-index))))]
      (cond (not has-title?) [0 (count text)]
            title? [0 (+ title-count title-index)]
            :else [(+ title-count title-index) (count text)]))))

;; C/P'ed from dre.components.document-annotations
(defn- mlower
  [x]
  (when-not (str/blank? x)
    (str/lower-case x)))

;; C/P'ed from dre.components.document-annotations
(defn- first-highlight-idx
  [annotation highlight-senses highlight-freetext]
  (let [text (or (:text annotation) "")
        lower-cased (str/lower-case text)
        highlights (:highlights annotation)
        query-senses (set highlight-senses)
        overlapping-freetext (fn [freetext start]
                               (when-let [idx (str/index-of lower-cased
                                                            freetext
                                                            start)]
                                 (if (and (pos? idx)
                                          (gstring/isAlphaNumeric
                                           (get lower-cased (dec idx))))
                                   (recur freetext (inc idx))
                                   idx)))
        idx (some #(overlapping-freetext % 0)
                  (map mlower highlight-freetext))
        overlapping-span (fn [highlight]
                           (some (fn [sense]
                                   (when (contains? query-senses sense)
                                     (first (:span highlight))))
                                 (:senses highlight)))
        idx (or idx (some overlapping-span highlights))
        until (subs text 0 (dec idx))
        last-index-of (str/last-index-of until " ")]
    ;; when last-index-of is nil, the snippet will be displayed from the start
    last-index-of))

(defn- ->start+end
  "Computes start and end indexes of abstracts in results widget"
  [annotated-body expanded? senses free-text]
  (let [max-len 140
        abstract-text (or (:text annotated-body) "")
        [span-start span-end] (annotation-span abstract-text nil false)
        start-context (first-highlight-idx annotated-body senses free-text)
        start (if expanded?
                span-start
                (or start-context span-start))
        end (if-not expanded?
              (min span-end (+ span-start max-len)) span-end)
        start (if-not expanded? start 0)
        end-context (when start-context
                      (or (document-util/space-index abstract-text
                                                     (+ start-context max-len))
                          span-end))
        end (if expanded?
              span-end
              (or end-context end))
        end (if-not expanded? end (count abstract-text))]
    [start end]))

(defn abstract
  [{:keys [guid abstract abstract-boldings abstract-picos annotated-body]} {:keys [expanded]}]
  (let [expanded? (contains? expanded guid)]
    [:div
     {:class [(bem/be component-name :abstract)]}
     (vec (cons :<>
                (for [section-idx (range (count abstract))]
                  (let [[start end] (->start+end (nth annotated-body section-idx)
                                                 expanded?
                                                 @(rf/subscribe [::results/senses])
                                                 @(rf/subscribe [::results/free-text]))]
                    [annotations/annotate
                     (nth abstract section-idx)
                     (nth abstract-boldings section-idx)
                     (nth abstract-picos section-idx)
                     start
                     end]))))
     [tooltip-wrapper (if expanded? "Show less" "Show more")
      [:a
       {:class (bem/be component-name :expand)
        :href "#"
        :on-click #(rf/dispatch [::results/toggle-expanded guid])}
       (if expanded? [tr "Show less"] [tr "Show more"])]]]))


(defn group
  [{:keys [group]} group? {:keys [highlight]}]
  (when (and group group?)
    [:div
     {:class (bem/bem component-name :group (when (= group (:group highlight)) :highlighted))}]))


(defn content
  [a state]
  [:<>
   [title a]
   [:div
    {:class (bem/be component-name :meta)}
    [meta/view a]
    [meta/related a]]
   [abstract a state]])

(defn content-no-abstract
  [a]
  [:<>
   [title a]
   [:div
    {:class (bem/be component-name :meta)}
    [meta/view a]]])

(defn content-no-abstract-nonclickable
  [a]
  [:<>
   [title-nonclickable a]
   [:div
    {:class (bem/be component-name :meta)}
    [meta/view a]]])

(defn new-box
  [a _state]
  (when (:new a)
    [:div
     {:class (bem/be component-name :new)}
      @(rf/subscribe [::i18n/translate "NEW"])]))


(defn score-box
  [{:keys [score]} {:keys [order]} user]
  (when (and (#{:scoretitle-desc} order)
             (dre-user? user)
             (admin-role? user)
             (not (str/blank? score)))
    [:div
     {:class (bem/be component-name :score)}
     (format "%.4f" score)]))

(defn ai-star
  [a state user]
  (let [active-widgets @(rf/subscribe [::widgets-events/active])
        active? (active-widgets qa-events/id)
        qa-data @(rf/subscribe [::qa-events/data])
        active-guids (qa-events/active-articles qa-data :article/guid)]
    (when (and active? (contains? active-guids (:guid a)))
      [tooltip-wrapper "Included in AI summarization"
       [:span
        {:class (bem/be component-name :col-ai-star-icon)}
        [icon :common :ai-star]]])))

(defn view
  [a group? state user]
  (let [highlight? (= (:guid a) (-> state :highlight :guid))]
    [:div
     {:class component-name
      :on-mouse-over #(rf/dispatch [::results/highlight a])
      :on-mouse-out #(rf/dispatch [::results/highlight nil])}
     [:div
      {:class (bem/be component-name :col-select)}
      [select a state]]
     [:div
      {:class (bem/be component-name :col-index)}
      [index a state]]
     [:div
      {:class (bem/be component-name :col-tag)}
      [tag a state user]
      [ai-star a state user]]
     [:div
      {:class (bem/be component-name :col-group)}
      [group a group? state]]
     [:div
      {:class [(bem/be component-name :col-content)
               :highlights
               (when highlight? :highlighted)]}
      [content a state]]
     [:div
      {:class (bem/be component-name :col-badges)}
      [new-box a state]
      [score-box a state user]]]))
